import styled from 'styled-components';
import { Menu } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

// Horizontal underline tabs, matching the Products page navigation.
export const StyledMenu = styled(Menu)`
  width: 100%;

  &&& .ant-menu-item-selected::after,
  &&& .ant-menu-item-active::after {
    border-bottom-color: ${COLORS.YELLOW_PRIMARY} !important;
  }

  &&& .ant-menu-item-disabled {
    cursor: not-allowed;
    pointer-events: auto;

    &:hover {
      background-color: transparent !important;

      &::after {
        border-bottom-color: transparent !important;
      }
    }
  }
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
  gap: 1.5rem;
`;

export const StyledTabLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;

  .anticon {
    color: ${COLORS.NORMAL_GRAY};
  }
`;
